import React, {Component} from 'react'
import {connect} from 'react-redux'
import {actions} from 'react-redux-form'
import {Grid, Row, Col} from 'react-bootstrap'
import EditUserGroupForm from './usergroup-edit-form'
import BackLink from '../../../common/back-link/index'
import PageTitle from "../../../common/page-title/index";
import {getUserGroup} from '../../../../actions/usergroups'

import './styles.css'
import Can from '../../../common/guards/can';

class EditUserGroup extends Component {

  constructor(props){
    super(props);
  }

  componentWillMount() {
    this.id = +this.props.match.params.id;
    this.props.dispatch(getUserGroup(this.id));
  }

  componentWillUnmount(){
    this.props.dispatch(actions.reset('deep.admin_usergroup'));
    this.props.dispatch({type: 'CLEAR_EDIT_USERGROUP'});
  }

  render(){
    return(
      <Grid bsClass="container" fluid className="usergroups">
        <Row>
          <Col lg={12}>
            <BackLink href="/admin/user-groups"/>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <PageTitle>Add/Edit usergroup</PageTitle>
          </Col>
        </Row>
        <EditUserGroupForm
          userGroup={this.props.userGroup}/>
      </Grid>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    ...state,
    userGroup: state.userGroups.userGroup,
    fetched: state.userGroups.fetched,
    fetching: state.userGroups.fetching,
  };
};

export default connect(mapStateToProps)(EditUserGroup);



// WEBPACK FOOTER //
// ./src/components/admin/usergroups/edit/index.jsx